import React from 'react';
import Marquee from 'react-fast-marquee';
import { Shield, Award, Star, CheckCircle, BadgeCheck, Medal } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const badges = [
  { icon: Shield, label: 'Satisfaction Guaranteed' },
  { icon: Award, label: 'Certified & Licensed Professionals' },
  { icon: Star, label: 'Top Rated Law Firm' },
  { icon: CheckCircle, label: 'Available By Appointment' },
  { icon: BadgeCheck, label: 'New York Bar Association' },
  { icon: Medal, label: 'Award-Winning Legal Team' },
  { icon: Shield, label: 'Client Confidentiality' },
  { icon: Award, label: '25+ Years Experience' },
];

export default function TrustBadges() {
  const { isDark } = useTheme();

  return (
    <section data-testid="trust-badges-section" className="py-16 border-y"
      style={{ borderColor: 'var(--color-border)', background: 'var(--color-bg)' }}
    >
      <Marquee
        speed={40}
        gradient={true}
        gradientColor={isDark ? '#020617' : '#FAFAFA'}
        gradientWidth={80}
      >
        {badges.map((badge, i) => {
          const Icon = badge.icon;
          return (
            <div
              key={i}
              data-testid={`trust-badge-${i}`}
              className="flex items-center gap-3 mx-10"
            >
              <Icon size={20} style={{ color: 'var(--color-accent)' }} strokeWidth={1.5} />
              <span className="font-body text-sm font-medium whitespace-nowrap tracking-wide"
                style={{ color: 'var(--color-text-muted)' }}
              >
                {badge.label}
              </span>
            </div>
          );
        })}
      </Marquee>
    </section>
  );
}
